define('SageDotCom/Components/Content/DotVu',["jquery"],
    function ($) {
        function DotVu(scope, dotId, pageId, itemId, loading, height, width, title, customLink, eventName) {
            var dotVuComponent = document.getElementById(itemId);

            var dotVuConfig = {
                dotId: dotId,
                pageId: pageId,
                loading: loading ? 'on' : 'off',
                loadingColor: 'rgba(200, 200, 200, 1)',
                height: height === "" ? 'auto' : height,
                width: width === "" ? '100%' : width,
                customdomainlink: customLink,
                eventName: eventName,
                title: title
            }

            //Check if the script is already injected
            var existingScript = document.querySelector('script#dot-embed-script');
            if (!existingScript) {
                // Create a new script element
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.id = 'dot-embed-script';
                script.innerHTML = `
		        window.dotEmbedConfig = { iframeFix: true };
                (function (w, d, o, u, a, f, e, n) {
                  w[a] = w[a] || {};
                  for (var i = 0; i < f.length; i++) {
                    w[a][f[i]] = w[a][f[i]] || function (i) {
                      return function () {
                        (w[a][f[i]].q = w[a][f[i]].q || []).push(arguments)
                      }
                    }(i)
                  } e = d.createElement(o),
                    n = d.getElementsByTagName(o)[0]; e.async = 1; e.src = u; n.parentNode.insertBefore(e, n)
                })(window, document, 'script',
                  'https://4500902784af655b3de3-5ad26d8a78e52ca19e00dd2d340c77bb.ssl.cf3.rackcdn.com/dot/js/dot-embed/dot-embed-3.1.js',
                  'dotEmbed',
                  ['load', 'onLoad']);
		        `;

                // Add the script to the head element
                var head = document.head || document.getElementsByTagName('head')[0];
                head.appendChild(script);
            }

           
                //only load if element is almost in view
                window.dotEmbed.load(dotVuComponent, dotVuConfig, function (page) {
                    const options = {
                        root: null, // default, use viewport
                        rootMargin: "0px",
                        threshold: 0.5 // half of item height
                    }
                    const callback = function (entries, observer) {
                        entries.forEach(entry => {
                            try {
                                if (entry.isIntersecting && page && page.actions && page.actions.run && typeof page.actions.run === "function") {
                                    page.actions.run("cameIntoView");
                                    observer.unobserve(dotVuComponent);
                                } else if (entry.isIntersecting) {
                                    console.warn("DotVu: page.actions.run is not a function or is undefined");
                                }
                            } catch (e) {
                                console.error("DotVu: An error occurred while running page.actions.run", e);
                            }

                        });
                    }
                    function createOneTimeObserver(element) {
                        const observer = new IntersectionObserver(callback, options);
                        observer.observe(element);
                    }
                    createOneTimeObserver(dotVuComponent);
                    if (eventName) {
                        page.events.subscribe("scroll", function () {
                            dotVuComponent.scrollIntoView()
                        });
                        page.events.subscribe(eventName, function ({ btnToClickId }) {
                            const btn = document.querySelector(btnToClickId);
                            if (btn) {
                                btn.click();
                            }
                        });
                    }
                });

        }

        DotVu.init = function init(args) {
            return args.IsEditorEditing === true
                ? null
                : new DotVu(args.scope, args.dotId, args.pageId, args.itemId, args.loading, args.height, args.width, args.title, args.customLink, args.eventName);
        };

        return DotVu;
    });
